import React, { useEffect, useState } from "react";
// import swiper react components
import { Swiper, SwiperSlide } from "swiper/react";
import { motion, AnimatePresence } from "framer-motion";
// import swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
// import required modules
import { EffectFade, Autoplay } from "swiper";
// images
import Hero1 from "../../assets/img/hero/hero1.jpg";
import Hero2 from "../../assets/img/hero/hero2.jpg";
import Hero3 from "../../assets/img/hero/hero3.jpg";

import Search from "../Search/Search";

const slides = [
  {
    bg: Hero1,
  },
  {
    bg: Hero2,
  },
  {
    bg: Hero3,
  },
];

const words = ["Propiedad", "Casa", "Departamento", "Oficina"];

const HeroSlider = () => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 5000); // Cambia cada 5 segundos

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <Swiper
        modules={[EffectFade, Autoplay]}
        effect={"fade"}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        className="heroSlider h-[100vh]"
      >
        {slides.map((slide, index) => {
          // destructure slide
          const { bg } = slide;
          return (
            <SwiperSlide
              className="h-full relative flex flex-col justify-center items-center"
              key={index}
            >
              <div className="z-20 text-white text-center">
                <h1 className="text-4xl lg:text-6xl font-bold leading-tight mb-6">
                  Tu{" "}
                  <span className="text-primary">
                    <AnimatePresence mode="wait">
                      <motion.span
                        key={words[currentWordIndex]}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.5 }}
                        className="inline-block"
                      >
                        {words[currentWordIndex]}
                      </motion.span>
                    </AnimatePresence>
                  </span>{" "}
                  ideal está acá.
                </h1>
              </div>
              <div className="w-full max mt-10 px-2">
                <Search />
              </div>

              {/* Transition effect for background image */}
              <motion.div
                className="absolute top-0 w-full h-full"
                key={bg}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
              >
                <img className="object-cover h-full w-full" src={bg} alt="" />
              </motion.div>

              {/* overlay */}
              <div className="absolute w-full h-full bg-black/40"></div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default HeroSlider;
